export const COLLECTIONS = {
    PUBLICIST: {
        CAMPAIGNS: 'publicist_campaigns',
        CONTACTS: 'publicist_contacts'
    },
    VIDEO: {
        JOBS: 'videoJobs'
    },
    FINANCE: {
        EARNINGS_REPORTS: 'earnings_reports'
    },
    MARKETPLACE: {
        SERVICES: 'marketplace_services'
    },
    SHOWROOM: {
        VENUES: 'venues'
    }
} as const;
